import React from "react";

const Users = () =>

<>
<h1 style={{fontSize : "180x", textAlign:"center"}}>UNDER DEVELOPMENT</h1>


</>

export default Users;
